import { React, useState } from 'react';
import Buttons2 from '../Buttons2';
import PreviewDialog from '../../Shared/Dialogs/preview/previewCard';
import GenericCard from '../../Shared/GenericCard';
import Rubricsnew from '../../../static/img/Rubricsnew.svg';
import { useHistory } from 'react-router-dom';
import { exportJsonFile } from '../../../components2/markingCriteria';
import { deleteMarkingCriteria, updateMarkingCriteria } from '../../../service';
import { toast } from 'react-toastify';
import Toast from '../../Toast';
import { buildMetadata } from '../../../utils/subjects';
import { useUserStates } from '../../../hooks/useUserStates';
import { useSubjects } from '../../../hooks/useSubjects';

function MarkingCriteriaCard(props) {
  const {
    markingCriteria,
    cloneMarkingCriteria = null,
    deleteMarkingCriteriaHandler = null,
    isSelected = false,
    onSelect,
    showCheckbox = false,
    disableNavigation = false,
  } = props;
  const [openMarkingCriteriaPreviewDialog, setMarkingCriteriaPreviewDialog] =
    useState(false);
  const history = useHistory();
  const { states: userStates } = useUserStates();
  const { rawSubjects: subjectsList } = useSubjects(userStates);

  function navigateToMarkingCriteriaUrl(id) {
    history.push(markingCriteriaUrl(id));
  }
  function markingCriteriaUrl(id) {
    return `/tools/rubrics/${id}`;
  }

  const downloadMarkingCriteria = (markingCriteria) => {
    const extractedMarkingCriteria = {
      title: markingCriteria.title,
      type: 'RUBRICS',
      criterias: markingCriteria.criterias,
    };
    exportJsonFile(
      extractedMarkingCriteria,
      extractedMarkingCriteria.title,
      'mc'
    );
  };

  const handleDeleteMarkingCriteria = (id) => {
    deleteMarkingCriteria(id)
      .then(() => {
        toast(<Toast message="Rubrics deleted successfully" />);
        window.location.reload();
      })
      .catch((error) => {
        toast(<Toast message="Failed to delete rubrics" />);
      });
  };

  const handleNavigate = (item) => {
    if (!disableNavigation) {
      navigateToMarkingCriteriaUrl(item.id);
    }
  };

  const getBadgeConfig = () => {
    return {
      icon: Rubricsnew,
      label: 'Rubric',
    };
  };

  const handleMarkingCriteriaClone = () => {
    if (cloneMarkingCriteria) {
      cloneMarkingCriteria();
    }
  };

  const handleMarkingCriteriaPreview = () => {
    setMarkingCriteriaPreviewDialog(true);
  };

  const handleMarkingCriteriaSettings = async (id, settings) => {
    try {
      const taskTypes = settings.taskTypes || (settings.taskType ? [settings.taskType] : []);
      const responseTypes = settings.responseTypes || (settings.responseType ? [settings.responseType] : []);
      const metadata = buildMetadata(userStates, {
        years: settings.years || [],
        subjects: settings.subjects || [],
        taskTypes,
        responseTypes,
      }, subjectsList);
      
      const updatePayload = {
        years: settings.years || [],
        subjects: settings.subjects || [],
        taskTypes,
        responseTypes,
        metadata
      };
      
      await updateMarkingCriteria(updatePayload, id);
      toast(<Toast message="Settings saved successfully" />);
      window.location.reload();
    } catch (error) {
      console.error('Error updating rubrics settings:', error);
      toast(<Toast message="Failed to save settings" />);
    }
  };

  const rightComponent = (
    <Buttons2
      item={markingCriteria}
      itemType="Rubrics"
      onDownload={downloadMarkingCriteria}
      onDelete={handleDeleteMarkingCriteria}
      onClone={handleMarkingCriteriaClone}
      onPreview={handleMarkingCriteriaPreview}
      onSettings={handleMarkingCriteriaSettings}
    />
  );

  return (
    <>
      <GenericCard
        item={markingCriteria}
        type="markingCriteria"
        isSelected={isSelected}
        onSelect={onSelect}
        showCheckbox={showCheckbox}
        rightComponent={rightComponent}
        onNavigate={handleNavigate}
        onPreview={handleMarkingCriteriaPreview}
        badgeConfig={getBadgeConfig()}
        isSystem={markingCriteria?.isSystem}
        disableNavigation={disableNavigation}
      />
      {openMarkingCriteriaPreviewDialog && (
        <PreviewDialog
          setMarkingCriteriaPreviewDialog={setMarkingCriteriaPreviewDialog}
          markingCriterias={markingCriteria}
          isSystem={markingCriteria?.isSystem}
        />
      )}
    </>
  );
}

export default MarkingCriteriaCard;
